var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3,0H1C0.4,0,0,0.4,0,1v4.3c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1V1C6.3,0.4,5.9,0,5.3,0z M13,7.6H8.6 c-0.6,0-1,0.4-1,1V13c0,0.6,0.4,1,1,1H13c0.6,0,1-0.4,1-1V8.6C14,8.1,13.5,7.6,13,7.6z M5.3,7.6H1c-0.6,0-1,0.4-1,1V13 c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1V8.6C6.3,8.1,5.9,7.6,5.3,7.6z M13,0H8.6c-0.6,0-1,0.4-1,1v4.3c0,0.6,0.4,1,1,1H13 c0.6,0,1-0.4,1-1V1C14,0.4,13.5,0,13,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/apps-icon.827be7968b2681216c7b94d7e8cda07e.svg";
export { ForwardRef as ReactComponent };